<span *ngIf="ticketCaption">{{ ticket.caption }} <span *ngIf="getCallingTime()">{{ getCallingTime() | date: 'HH:mm':'UTC' }}</span></span>
<span *ngIf="!ticketCaption">---</span>
